import axios from "axios";
import enviromment from '../../environment';

const AuthApi = axios.create({
  baseURL: enviromment.apiAccount,
  withCredentials: true
  
});

export default AuthApi;